// Types
// MUST match server types

export const LinkTypes = {
  activityLog: 'activityLog',
  autoRule: 'autoRule',
  comment: 'comment',
  account: 'account',
  accountLocation: 'accountLocation',
  contact: 'contact',
  contactAddress: 'contactAddress',
  contactPerson: 'contactPerson',
  contactCreditInfo: 'contactCreditInfo',
  order: 'order',
  orderItem: 'orderItem',
  purchaseOrder: 'purchaseOrder',
  user: 'user',
  userGroup: 'userGroup',
  autoSub: 'autoSub',
  stock: 'stock',
  stockCategory: 'stockCategory',
  stockContainer: 'stockContainer',
  inventoryBin: 'inventoryBin',
  inventoryBinLink: 'inventoryBinLink',
  stockTake: 'stockTake',
  customerPriceList: 'customerPriceList',
  stockPriceGroup: 'stockPriceGroup',
  salesRate: 'salesRate',
  servicePriceRange: 'servicePriceRange',
  stockPriceRequestGroup: 'stockPriceRequestGroup',
  priceListConfig: 'priceListConfig',
  priceListTemplate: 'priceListTemplate',
  glassLevel: 'glassLevel',
  glassSize: 'glassSize',
  glassSalesPrice: 'glassSalesPrice',
  glassThickness: 'glassThickness',
  orderEditorLibraryItem: 'orderEditorLibraryItem',
  optimiserSheet: 'optimiserSheet',
  productionPanel: 'productionPanel',
  productionStage: 'productionStage',
  productionStation: 'productionStation',
  tougheningBatch: 'tougheningBatch',
  resourceGroup: 'resourceGroup',
  resource: 'resource',
  task: 'task',
  taskType: 'taskType',
  taskItem: 'taskItem',
  taskUserRoute: 'taskUserRoute',
  taskUserRouteEvent: 'taskUserRouteEvent',
  invoice: 'invoice',
  invoiceItem: 'invoiceItem',
  paymentReceived: 'paymentReceived',
  invoicePayment: 'invoicePayment',
  overPayment: 'overPayment',
  creditNote: 'creditNote',
  creditNoteItem: 'creditNoteItem',

  aiAgent: 'aiAgent',
  aiAgentReport: 'aiAgentReport',
  aiConversation: 'aiConversation',

  // Non-db-model classes
  taskOrderGroup: 'TaskOrderGroup',  
  requiredContainerInfo: 'RequiredContainerInfo',

  // Link sub-types
  orderItemNCR: 'orderItemNCR',
  productionPanelRecut: 'productionPanelRecut',
  contactAddressDelivery: 'contactAddressDelivery',
  glassLevelIssue: 'glassLevelIssue',
  taskPartialScanIn: 'taskPartialScanIn',
  taskItemLateArrival: 'taskItemLateArrival',
  taskItemPartialScanOut: 'taskItemPartialScanOut',
  taskItemStoppage: 'taskItemStoppage',
  taskItemCancellation: 'taskItemCancellation'
}
// TODO: Add in support for more
export const LinkTypeLookup = [
  { name: 'Order', value: LinkTypes.order },
  { name: 'Task', value: LinkTypes.task },
  { name: 'Task Item', value: LinkTypes.taskItem },
  { name: 'Task Type', value: LinkTypes.taskType },
  { name: 'Task Route', value: LinkTypes.taskUserRoute },
  { name: 'Task Route Event', value: LinkTypes.taskUserRouteEvent },
  { name: 'Account', value: LinkTypes.account },
  { name: 'Account Location', value: LinkTypes.accountLocation },
  { name: 'Invoice', value: LinkTypes.invoice },
  { name: 'Purchase Order', value: LinkTypes.purchaseOrder },
  { name: 'User', value: LinkTypes.user },
  { name: 'Stock', value: LinkTypes.stock },
  { name: 'Inventory Bin', value: LinkTypes.inventoryBin },
  { name: 'Inventory Bin Link', value: LinkTypes.inventoryBinLink },
  { name: 'Glass Level', value: LinkTypes.glassLevel },
  { name: 'Glass Size', value: LinkTypes.glassSize },
  { name: 'Order Editor Library Item', value: LinkTypes.orderEditorLibraryItem },
  { name: 'Stocktake', value: LinkTypes.stockTake },
  { name: 'Contact', value: LinkTypes.contact },
  { name: 'Contact Person', value: LinkTypes.contactPerson },
  { name: 'Contact Address', value: LinkTypes.contactAddress },
  { name: 'Contact Credit Info', value: LinkTypes.contactCreditInfo },
  { name: 'Payment Received', value: LinkTypes.paymentReceived },
  { name: 'Credit Note', value: LinkTypes.creditNote },
  { name: 'Task Order Group', value: LinkTypes.taskOrderGroup },
  { name: 'Production Panel', value: LinkTypes.productionPanel },
  { name: 'Glass Block', value: LinkTypes.glassBlock },
  { name: 'Required Container Info', value: LinkTypes.requiredContainerInfo },

  { name: 'AI Agent', value: LinkTypes.aiAgent },
  { name: 'AI Agent Report', value: LinkTypes.aiAgentReport },
  { name: 'AI Conversation', value: LinkTypes.aiConversation },

  { name: 'Activity Log Comment', value: LinkTypes.comment },

  { name: 'Order Item NCR', value: LinkTypes.orderItemNCR },
  { name: 'Panel Recut', value: LinkTypes.productionPanelRecut },
  { name: 'Address Despatch Tag', value: LinkTypes.contactAddressDelivery },
  { name: 'Offcut Issue', value: LinkTypes.glassLevelIssue },
  { name: 'Task Partial Scan In', value: LinkTypes.taskPartialScanIn },
  { name: 'Task Item Late Arrival', value: LinkTypes.taskItemLateArrival },
  { name: 'Task Item Partial Scan Out', value: LinkTypes.taskItemPartialScanOut },
  { name: 'Task Item Stoppage', value: LinkTypes.taskItemStoppage },
  { name: 'Task Item Cancellation', value: LinkTypes.taskItemCancellation },
]

export const ActivityItemTypes = {
  activityLog: 'activityLog',
  comment: 'comment'
}

export const ActivityLogTypes = {
  created: 'created',
  updated: 'updated',
  deleted: 'deleted',
  archived: 'archived',
  restored: 'restored',
  status: 'status',
  action: 'action',
  error: 'error',
  approved: 'approved',
  denied: 'denied',
  emailed: 'emailed',
  printed: 'printed'
}
export const ActivityLogTypeLookup = [
  { name: 'Created', value: ActivityLogTypes.created },
  { name: 'Updated', value: ActivityLogTypes.updated },
  { name: 'Deleted', value: ActivityLogTypes.deleted },
  { name: 'Archived', value: ActivityLogTypes.archived },
  { name: 'Restored', value: ActivityLogTypes.restored },
  { name: 'Status', value: ActivityLogTypes.status },
  { name: 'Action', value: ActivityLogTypes.action },
  { name: 'Error', value: ActivityLogTypes.error },
  { name: 'Approved', value: ActivityLogTypes.approved },
  { name: 'Denied', value: ActivityLogTypes.denied },
  { name: 'Emailed', value: ActivityLogTypes.emailed },
  { name: 'Printed', value: ActivityLogTypes.printed }
]

export const PermissionStateTypes = {
  mixed: 'mixed',   // Client side only
  inherit: 'inherit',
  allow: 'allow',
  deny: 'deny'
}
export const PermissionAccessTypes = {
  create: 'create',
  read: 'read',
  update: 'update',
  delete: 'delete'
}

export const PersonTitleLookup = [
  { name: 'Mr' },
  { name: 'Mrs' },
  { name: 'Miss' },
  { name: 'Ms' },
  { name: 'None', value: '' }
]

export const CommLogTypeLookup = [
  { name: 'Phone', value: 'phone' },
  { name: 'Email', value: 'email' },
  { name: 'Person', value: 'person' },
  { name: 'Misc', value: 'misc' }
]

export const CalendarEventTypes = {
  closure: 'closure'
}
export const CalendarEventTypeLookup = [
  { name: 'Closure', value: CalendarEventTypes.closure }
]

export const DespatchTypes = {
  delivery: 'delivery',
  pickup: 'pickup'
}
export const DespatchTypeLookup = [
  { name: 'Delivery', value: 'delivery' },
  { name: 'Pickup', value: 'pickup' }
]

export const DeliveryPricingTypes = {
  fixed: 'fixed',
  percent: 'percent'
}
export const DeliveryPricingTypeLookup = [
  { name: 'Fixed', value: 'fixed' },
  { name: 'Percent', value: 'percent' }
]

// Account pricing system types
export const PricingSystemTypes = {
  simple: 'simple',     // No customer price lists, just default sales rates
  complex: 'complex'    // Customer price lists
}
export const PricingSystemTypeLookup = [
  { name: 'Simple', value: PricingSystemTypes.simple },
  { name: 'Complex', value: PricingSystemTypes.complex }
]

export const CreditTypes = {
  prepaid: 'prepaid',
  cod: 'cod',
  account: 'account'
}

export const CreditTypeLookup = [
  { name: 'Prepaid', value: 'prepaid' },
  { name: 'Cash On Delivery', value: 'cod' },
  { name: 'Credit Account', value: 'account' }
]

export const CreditStatusTypes = {
  active: 'active',
  onhold: 'onhold',
  stop: 'stop'
}
export const CreditStatusLookup = [
  { name: 'Active', value: 'active' },
  { name: 'On Hold', value: 'onhold' },
  { name: 'Stopped', value: 'stop' }
]

export const ContactLabelTypes = {
  delivery: 'delivery',       // ContactAddresses flagged for delivery
  accounts: 'accounts',       // ContactPerson flagged for accounts
  orders: 'orders',           // ContactPerson flagged for orders
  onsiteAddress: 'onsiteAddress',   // contactAddressDelivery for onsite (custom address)
}

export const DespatchChargeTypes = {
  order: 'order',     // 1 Despatch Fee per order
  task: 'task'        // 1 Despatch Fee per despatch task
}
export const DespatchChargeTypeLookup = [
  { name: 'Per Order', value: DespatchChargeTypes.order },
  { name: 'Per Task', value: DespatchChargeTypes.task }
]

export const PaymentTermTypes = {
  daysAfterBill: 'daysAfterBill',
  daysAfterEndMonth: 'daysAfterEndMonth',
  dayOfTheFollowingMonth: 'dayOfTheFollowingMonth',
  dayOfTheCurrentMonth: 'dayOfTheCurrentMonth'
}
export const PaymentTermLookup = [
  { name: 'day(s) after bill', value: 'daysAfterBill' },
  { name: 'day(s) after end of month', value: 'daysAfterEndMonth' },
  { name: 'day of the following month', value: 'dayOfTheFollowingMonth' },
  { name: 'day of the current month', value: 'dayOfTheCurrentMonth' },
]

export const ContactEntityTypes = {
  none: 'none',
  soleTrader: 'soleTrader',
  company: 'company',
  trust: 'trust',
  partner: 'partner'
}
export const ContactEntityLookup = [
  { name: 'None', value: 'none' },
  { name: 'Sole Trader', value: 'soleTrader' },
  { name: 'Company', value: 'company' },
  { name: 'Trust', value: 'trust' },
  { name: 'Partner', value: 'partner' },
]

export const SupplierTypes = {
  none: 'none',
  import: 'import',
  local: 'local'
}
export const SupplierTypeLookup = [
  { name: 'None', value: 'none' },
  { name: 'Import', value: 'import' },
  { name: 'Local', value: 'local' },
]

export const IntegrationTypeCodes = {
  xero: 'xero',
  myob: 'myob',
  claude: 'claude'
}

// Generic Filter Types
export const FilterOptionTypes = {
  all: 'all',
  include: 'include',
  exclude: 'exclude',
  none: 'none'
}

/**
 * Automations
 */
export const AutomationFieldTypes = {
  enum: 'enum',
  boolean: 'boolean',
  currency: 'currency',
  number: 'number',
  text: 'text',
  textArea: 'textArea',
  time: 'time',
  tagList: 'tagList',
  dayOfMonth: 'dayOfMonth',
  dayOfYear: 'dayOfYear',
  userList: 'userList',
  userGroupList: 'userGroupList',
  permissionList: 'permissionList',
  aiAgentReport: 'aiAgentReport',
  dynamicList: 'dynamicList',       // LinkType will be set in field info
  labelList: 'labelList'
}
export const AutomationFieldCompareTypes = {
  equals: 'equals',
  notEquals: 'notEquals',
  isSet: 'isSet',

  // Enums
  isOneOf: 'isOneOf',
  isNotOneOf: 'isNotOneOf',

  updated: 'updated',   // DEPRECATED

  // Number values
  greaterThen: 'greaterThen',
  equalOrGreaterThen: 'equalOrGreaterThen',
  lessThen: 'lessThen',
  equalOrLessThen: 'equalOrLessThen',
}
export const AutomationFieldCompareTypeLookup = [
  { name: 'Equals', value: AutomationFieldCompareTypes.equals },
  { name: 'Not equals', value: AutomationFieldCompareTypes.notEquals },
  { name: 'Is Set', value: AutomationFieldCompareTypes.isSet },
  { name: 'Is One Of', value: AutomationFieldCompareTypes.isOneOf },
  { name: 'Is Not One Of', value: AutomationFieldCompareTypes.isNotOneOf },
  { name: 'Greater Then', value: AutomationFieldCompareTypes.greaterThen },
  { name: 'Equal or Greater Then', value: AutomationFieldCompareTypes.equalOrGreaterThen },
  { name: 'Less Then', value: AutomationFieldCompareTypes.lessThen },
  { name: 'Equal or Less Then', value: AutomationFieldCompareTypes.equalOrLessThen },
]

export const AutomationComponentTypes = {
  trigger: 'trigger',
  condition: 'condition',
  branch: 'branch',
  action: 'action'
}
export const AutomationComponentTypeLookup = [
  { name: 'Trigger', value: AutomationComponentTypes.trigger },
  { name: 'Condition', value: AutomationComponentTypes.condition },
  { name: 'Branch', value: AutomationComponentTypes.branch },
  { name: 'Action', value: AutomationComponentTypes.action },
]

export const AutomationTriggerTypes = {
  event: 'event',             // Triggers based on event
  schedule: 'schedule',       // Triggers on a schedule
  manual: 'manual',           // Manually triggered
}

export const AutomationScheduleIntervalTypes = {
  daily: 'daily',               // Daily - Uses Day List for filtering by day
  monthly: 'monthly',           // Monthly - Has day of month filtering
  yearly: 'yearly'              // Yearly - Has day / month filtering
}
export const AutomationScheduleIntervalTypeLookup = {
  daily: 'Daily',
  monthly: 'Monthly',
  yearly: 'Yearly'
}

// For daily filtering
export const AutomationScheduleDayTypes = {
  sunday: 'sunday',
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
}
export const AutomationScheduleDayTypeLookup = {
  sunday: 'Sunday',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
}
export const AutomationLogTypes = {
  communication: 'communication',
  message: 'message',
  warning: 'warning',
  error: 'error'
}
export const AutomationLogTypeLookup = [
  { name: 'Communication', value: AutomationLogTypes.communication },
  { name: 'Message', value: AutomationLogTypes.message },
  { name: 'Warning', value: AutomationLogTypes.warning },
  { name: 'Error', value: AutomationLogTypes.error }
]


// DEPRECATED
export const AutomationSubscriptionTypes = {
  system: 'system',
  custom: 'custom'
}
export const AutomationSubscriptionTypeLookup = [
  { name: 'System', value: 'system' },
  { name: 'Custom', value: 'custom' }
]


// Inventory

export const InventoryStockTypes = {
  glass: 'glass',
  glassService: 'glassService',
  template: 'template',
  general: 'general',
  assembly: 'assembly'
}
export const InventoryStockTypeLookup = [
  { name: 'Glass', value: 'glass' },
  { name: 'Glass Service', value: 'glassService' },
  { name: 'Template', value: 'template' },
  { name: 'General', value: 'general' },
  { name: 'Assembly', value: 'assembly' },
]

export const UOMTypes = {
  each: 'each',
  length: 'length',
  metresq: 'm2',
  volume: 'volume',
  mass: 'mass',
  time: 'time',

  // Percentages. Pricing will be stored as a whole number percentage (0-100)
  percentOfLineItem: 'percentOfLineItem',
  percentOfOrder: 'percentOfOrder',

  // Capacity Specific Types
  eachSubItem: 'eachSubItem',  // Per sub-item / child order items (eg, services, assembly-sub-items, etc). Used only in production stations
}
// Lookup for Select input fields
export const UOMTypeLookup = [
  { name: 'Each', value: 'each' },
  { name: 'Lineal Metres', value: 'length' },
  { name: 'Metres Squared', value: 'm2' },
  { name: 'Volume', value: 'volume' },
  { name: 'Mass', value: 'mass' },
  { name: 'Time', value: 'time' },
  { name: 'Percentage Of Line Item', value: 'percentOfLineItem' },
  { name: 'Percentage Of Order', value: 'percentOfOrder' },
  { name: 'Each Sub Item', value: 'eachSubItem' },
]
// Lookup for units display (has html escape codes)
export const UOMTypeUnitsLookup = [
  { name: 'Ea', value: 'each' },
  { name: 'm', value: 'length' },
  { name: 'm&sup2;', value: 'm2' },
  { name: 'm&sup3;', value: 'volume' },
  { name: 'Kg', value: 'mass' },
  { name: 'Min', value: 'time' },
  { name: '%', value: 'percentOfLineItem' },
  { name: '%', value: 'percentOfOrder' },
  { name: 'Ea', value: 'eachSubItem' },
]
// Safe (no html) UoM type suffix
export const UOMTypeUnitsSafeLookup = [
  { name: 'Ea', value: 'each' },
  { name: 'm', value: 'length' },
  { name: 'm2', value: 'm2' },
  { name: 'm3;', value: 'volume' },
  { name: 'Kg', value: 'mass' },
  { name: 'Min', value: 'time' },
  { name: '%', value: 'percentOfLineItem' },
  { name: '%', value: 'percentOfOrder' },
  { name: 'Ea', value: 'eachSubItem' },
]

export const GlassTypes = {
  all: 'all',
  annealed: 'annealed',
  laminated: 'laminated'
}
export const GlassTypeLookup = [
  { name: 'All', value: GlassTypes.all },
  { name: 'Annealed', value: GlassTypes.annealed },
  { name: 'Laminated', value: GlassTypes.laminated },
]

export const StockFaceTypes = {
  smooth: 'smooth',
  rough: 'rough'
}
export const StockFaceTypeLookup = [
  { name: 'Smooth / Non-coated', value: StockFaceTypes.smooth },
  { name: 'Rough / Coated', value: StockFaceTypes.rough },
]
export const StockFaceLayerTypes = {
  none: 'none',   // For not-two-faced
  pattern: 'pattern',
  coated: 'coated'
}
export const StockFaceLayerTypeLookup = [
  { name: 'None', value: StockFaceLayerTypes.none },
  { name: 'Pattern', value: StockFaceLayerTypes.pattern },
  { name: 'Coated', value: StockFaceLayerTypes.coated },
]

export const StockGrainDirectionTypes = {
  none: 'none',
  vertical: 'vertical',
  horizontal: 'horizontal'
}
export const StockGrainDirectionTypeLookup = [
  { name: 'None', value: StockGrainDirectionTypes.none },
  { name: 'Vertical', value: StockGrainDirectionTypes.vertical },
  { name: 'Horizontal', value: StockGrainDirectionTypes.horizontal },
]
export const StockMaterialTypes = {
  colour: 'colour',
  gradient: 'gradient',
  reedTexture: 'reedTexture',
  cathedralTexture: 'cathedralTexture',
  satinliteTexture: 'satinliteTexture',
  spotswoodTexture: 'spotswoodTexture'
}
export const StockMaterialTypeLookup = [
  { name: 'Colour', value: StockMaterialTypes.colour },
  { name: 'Gradient', value: StockMaterialTypes.gradient },
  { name: 'Reeded', value: StockMaterialTypes.reedTexture },
  { name: 'Cathedral', value: StockMaterialTypes.cathedralTexture },
  { name: 'Satinlite', value: StockMaterialTypes.satinliteTexture },
  { name: 'Spotswood', value: StockMaterialTypes.spotswoodTexture },
]

// General Stock Profile Types
export const StockProfileTypes = {
  none: 'none',
  rhs: 'rhs',               // Rectangle - Hollow
  rectSolid: 'rectSolid',   // Rectangle - Solid
}
export const StockProfileTypeLookup = [
  { name: 'None', value: StockProfileTypes.none },
  { name: 'RHS', value: StockProfileTypes.rhs },
  { name: 'Rectangle Solid', value: StockProfileTypes.rectSolid },
]

// Join types for corners in m^2 assemblies (eg, window frames, IGUs)
// Used for the lengths around a glass unit (eg, channels, spacer bars)
export const StockAssemblyJoinTypes = {
  corner: 'corner',     // Just direct corner
  mitre: 'mitre',       // 45deg mitre between lengths,
  butt: 'butt',         // Pieces butt up against each other
  rounded: 'rounded'    // Continious length with a corner radius
}
export const StockAssemblyJoinTypeLookup = [
  { name: 'Corner', value: StockAssemblyJoinTypes.corner },
  { name: 'Mitre', value: StockAssemblyJoinTypes.mitre },
  { name: 'Butt', value: StockAssemblyJoinTypes.butt },
  { name: 'Rounded', value: StockAssemblyJoinTypes.rounded },
]

// Assembly Structure Types
// How the assembly is put together
export const StockAssemblyStructureTypes = {
  layered: 'layered',   // Layered with glass items on top of each other. Eg, IGU / Windows
  custom: 'custom',     // Custom structure, assembled in a user defined method
}
export const StockAssemblyStructureTypeLookup = [
  { name: 'Layered', value: StockAssemblyStructureTypes.layered },
  { name: 'Custom', value: StockAssemblyStructureTypes.custom }
]


export const StockTransactionDirectionTypes = {
  in: 'in',
  out: 'out',
  moved: 'moved'
}
export const StockTransactionDirectionTypeLookup = [
  { name: 'In', value: StockTransactionDirectionTypes.in },
  { name: 'Out', value: StockTransactionDirectionTypes.out },
  { name: 'Moved', value: StockTransactionDirectionTypes.moved }
]
export const StockTransactionTypes = {
  manual: 'manual',                         // Manually entered
  blockOpened: 'blockOpened',               // Block opened & converted to sheets
  purchaseOrder: 'purchaseOrder',           // Stock created from receiving purchase order
  salesOrder: 'salesOrder',                 // Stock sold via order
  processed: 'processed',                   // Sheet pushed through production
  stockTakeAdjust: 'stockTakeAdjust',       // Adjustment via stocktake
  offcut: 'offcut',                         // Offcut created from production
}
export const StockTransactionTypeLookup = [
  { name: 'Manually Set', value: StockTransactionTypes.manual },
  { name: 'Block Opened', value: StockTransactionTypes.blockOpened },
  { name: 'Purchase Order', value: StockTransactionTypes.purchaseOrder },
  { name: 'Sales Order', value: StockTransactionTypes.salesOrder },
  { name: 'Processed', value: StockTransactionTypes.processed },
  { name: 'Stocktake', value: StockTransactionTypes.stockTakeAdjust },
  { name: 'Offcut', value: StockTransactionTypes.offcut },
]

// Stocktake Status
export const StocktakeStatusTypes = {
  counting: 'counting',
  review: 'review',         // Review, awaiting confirmation
  recount: 'recount',       // Recount mode, only update stock items flagged for recount
  completed: 'completed',   // Completed & inventory levels applied
  cancelled: 'cancelled',
}
export const StocktakeStatusTypeLookup = [
  { name: 'Counting', value: StocktakeStatusTypes.counting },
  { name: 'Review', value: StocktakeStatusTypes.review },
  { name: 'Recount', value: StocktakeStatusTypes.recount },
  { name: 'Completed', value: StocktakeStatusTypes.completed },
  { name: 'Cancelled', value: StocktakeStatusTypes.cancelled },
]

export const StocktakeItemTypes = {
  generalStock: 'generalStock',
  glassOffcut: 'glassOffcut',
  glassLevel: 'glassLevel',
}
export const StocktakeItemTypeLookup = [
  { name: 'General Stock', value: StocktakeItemTypes.generalStock },
  { name: 'Glass Offcut', value: StocktakeItemTypes.glassOffcut },
  { name: 'Glass Stock', value: StocktakeItemTypes.glassLevel },
]

export const InventoryBinCodeTypes = {
  simple: 'simple',
  detailed: 'detailed'
}
export const InventoryBinCodeTypeLookup = [
  { name: 'Simple', value: InventoryBinCodeTypes.simple },
  { name: 'Detailed', value: InventoryBinCodeTypes.detailed },
]

export const InventoryBinLinkTypes = {
  glassLevel: 'glassLevel',
  stock: 'stock'
}

export const InventoryLabelTypes = {
  defaultReceiving: 'defaultReceiving',                 // For InventoryBin associated with receiving
  defaultProductionStock: 'defaultProductionStock',     // For InventoryBin associated with stock source for production
  defaultProduction: 'defaultProduction',               // For InventoryBin associated with production generated items
  defaultDespatch: 'defaultDespatch',                   // For InventoryBin associated with despatch
}

// Pricing
export const PriceTypes = {
  supplier: 'supplier',
  customer: 'customer',
  sales: 'sales'
}
export const StockPriceTypes = {
  general: 'general',
  bulkContainer: 'bulkContainer',
  processedPriceGroup: 'processedPriceGroup',
  servicePriceRange: 'servicePriceRange',
  assembly: 'assembly',
}
// Approval Types
export const ApprovalTypes = {
  pending: 'pending',
  approved: 'approved',
  denied: 'denied'
}
export const ApprovalTypeLookup = [
  { name: 'Pending', value: ApprovalTypes.pending },
  { name: 'Approved', value: ApprovalTypes.approved },
  { name: 'Denied', value: ApprovalTypes.denied }
]

export const PriceRequestTypes = {
  supplier: 'supplier',
  customer: 'customer',
  sales: 'sales'
}
export const PriceRequestTypeLookup = [
  { name: 'Supplier', value: PriceRequestTypes.supplier },
  { name: 'Customer', value: PriceRequestTypes.customer },
  { name: 'Sales', value: PriceRequestTypes.sales },
]

// Pricing Request Status Types
export const PricingRequestStatusTypes = {
  draft: 'draft',
  generatingPriceLists: 'generatingPriceLists',
  pendingApproval: 'pendingApproval',
  pendingSchedule: 'pendingSchedule',
  processing: 'processing',   // Currently being processed by system
  completed: 'completed',     // Approved & processed
  cancelled: 'cancelled'      // Denied / Cancelled.
}
export const PricingRequestStatusTypeLookup = [
  { name: 'Draft', value: PricingRequestStatusTypes.draft },
  { name: 'Generating Pricelists', value: PricingRequestStatusTypes.generatingPriceLists },
  { name: 'Pending Approval', value: PricingRequestStatusTypes.pendingApproval },
  { name: 'Pending Schedule', value: PricingRequestStatusTypes.pendingSchedule },
  { name: 'Processing', value: PricingRequestStatusTypes.processing },
  { name: 'Completed', value: PricingRequestStatusTypes.completed },
  { name: 'Cancelled', value: PricingRequestStatusTypes.cancelled }
]

// Customer Pricing
// Customer Override Types
export const CustomerOverrideTypes ={
  price: 'price',
  rate: 'rate'
}

// Customer Override Level
export const CustomerOverrideLevelTypes = {
  stock: 'stock',
  category: 'category',
}

// Price List Config - Display Types
export const PriceListConfigDisplayTypes = {
  show: 'show',
  hide: 'hide',
  inherit: 'inherit', // For customer config
  mixed: 'mixed'    // For categories
}

// Price List Config - Entry Types
export const PriceListConfigEntryTypes = {
  category: 'category',
  stock: 'stock'
}

// Price List source data types
// How new price lists source the stock pricing data
export const PriceListDataSourceTypes = {
  pendingPricing: 'pendingPricing',
  approvedPricing: 'approvedPricing'
}

// Price List data integration type
// How new price lists integrate into pending price requests
export const PriceListIntegrationTypes = {
  includePending: 'includePending',                 // Include into pending price request
  seperatePriceRequest: 'seperatePriceRequest',     // Completely seperate price request
  seperatePriceRequestLinkSource: 'seperatePriceRequestLinkSource'    // Seperate price request, but link to pending sales prices as source data
}

export const BulkUpdateAdjustmentTypes = {
  increasePercent: 'increasePercent',
  decreasePercent: 'decreasePercent',
  increaseAmount: 'increaseAmount',
  decreaseAmount: 'decreaseAmount'
}

// Orders
export const OrderTypes = {
  quote: 'quote',
  order: 'order',
  nonChargeableRework: 'nonChargeableRework'             // NCR:- Non Chargeable Rework
}
export const OrderTypeLookup = [
  { name: 'Quote', value: OrderTypes.quote },
  { name: 'Order', value: OrderTypes.order },
  { name: 'NCR', value: OrderTypes.nonChargeableRework }
]
export const OrderStatusTypes = {
  draft: 'draft',                             // Draft mode. Used if other people need to review the order before processing it
  processing: 'processing',                   // Various checks & processes are run against the order (eg, optimisation stock check) immediately after creation
  pendingAccountApproval: 'pendingAccountApproval',   // Pending account approvals for customer account status or pricing errors
  pendingProductionApproval: 'pendingProductionApproval',     // Pending production approvals
  quotePendingSent: 'quotePendingSent',           // Quote Only: Quote is waiting to be sent to the customer
  pendingCustomerApproval: 'pendingCustomerApproval',     // Pending customer response for either quote or order items require customer approval
  pendingPrePaid: 'pendingPrePaid',           // PrePaid Only: Order requires payment before continuing
  pendingExternalSetup: 'pendingExternalSetup', // Pending setup of the external items
  preProduction: 'preProduction',             // Pre-Production step to do print outs / communications with customer
  production: 'production',                   // Order items sent into production
  pendingCODPaid: 'pendingCODPaid',           // COD Only: Order requires payment before continuing to despatch
  despatch: 'despatch',                       // Production complete & now awaiting despatch
  ncrPendingReturn: 'ncrPendingReturn',       // NCR Only: Waiting for the return of broken/damaged items & approving/rejecting them
  completed: 'completed',                     // All stock received by customer & completed. Usually also invoiced if regular order
  denied: 'denied',                           // Order approval was denied. Can be revised & run through approval again
  cancelled: 'cancelled'                      // Order Cancelled. Cannot be restored
}
export const OrderStatusTypeLookup = [
  { name: 'Draft', value: OrderStatusTypes.draft },
  { name: 'Processing', value: OrderStatusTypes.processing },
  { name: 'Pending Accounts Approval', value: OrderStatusTypes.pendingAccountApproval },
  { name: 'Pending Production Approval', value: OrderStatusTypes.pendingProductionApproval },
  { name: 'Pending Quote Sent', value: OrderStatusTypes.quotePendingSent },
  { name: 'Pending Customer Approval', value: OrderStatusTypes.pendingCustomerApproval },
  { name: 'Pending Pre-paid', value: OrderStatusTypes.pendingPrePaid },
  { name: 'Pending External Setup', value: OrderStatusTypes.pendingExternalSetup },
  { name: 'Pre Production', value: OrderStatusTypes.preProduction },
  { name: 'Production', value: OrderStatusTypes.production },
  { name: 'Pending COD', value: OrderStatusTypes.pendingCODPaid },
  { name: 'Despatch', value: OrderStatusTypes.despatch },
  { name: 'NCR Pending Return', value: OrderStatusTypes.ncrPendingReturn },
  { name: 'Completed', value: OrderStatusTypes.completed },
  { name: 'Denied', value: OrderStatusTypes.denied },
  { name: 'Cancelled', value: OrderStatusTypes.cancelled }
]
export const OrderApprovalTypes = {
  production: 'production',                   // Production approval required for orders outside of production guidelines (glass editor) or stock levels
  pricing: 'pricing',                         // Pricing approval required for orders with prices below customer pricing
  customer: 'customer',                       // Customer approval required for orders requiring customer approval (used for quotes too)
  account: 'account',                         // Account approval required for orders going above customer credit or customer credit is hold/stopped
  ncrOrderItem: 'ncrOrderItem'                // An OrderItem is flagged for NCR and needs approval. Note: This is post-production and if denied will cause charging
}

export const OrderChecklistItemTypes = {
  sendOrderConfirmation: 'sendOrderConfirmation',
  printProductionSheets: 'printProductionSheets',
  printProductionLabels: 'printProductionLabels',
}
export const OrderChecklistItemTypeLookup = [
  { name: 'Send Order Confirmation', value: OrderChecklistItemTypes.sendOrderConfirmation },
  { name: 'Print Production Sheets', value: OrderChecklistItemTypes.printProductionSheets },
  { name: 'Print Production Labels', value: OrderChecklistItemTypes.printProductionLabels },
]

export const OrderChecklistStatusTypes = {
  pending: 'pending',
  completed: 'completed',
  skipped: 'skipped'
}
export const OrderChecklistStatusTypeLookup = [
  { name: 'Pending', value: OrderChecklistStatusTypes.pending },
  { name: 'Completed', value: OrderChecklistStatusTypes.completed },
  { name: 'Skipped', value: OrderChecklistStatusTypes.skipped }
]

export const OrderHoldTypes = {
  customer: 'customer',     // Customer requested hold
  accounts: 'accounts',     // Issue with accounts / payments. Requires 'orderAccountsApproval' permission to release hold
  orderEditing: 'orderEditing',   // Order is being edited
  stock: 'stock',           // Issue with stock
  production: 'production'  // Issue flagged from production
}
export const OrderHoldTypeLookup = [
  { name: 'Customer Requested', value: OrderHoldTypes.customer },
  { name: 'Accounts', value: OrderHoldTypes.accounts },
  { name: 'Order Editing', value: OrderHoldTypes.orderEditing },
  { name: 'Stock', value: OrderHoldTypes.stock },
  { name: 'Production', value: OrderHoldTypes.production }
]

export const OrderPaymentTypes = {
  prepaid: 'prepaid',   // Prepaid - Will invoice before production/despatch
  cod: 'cod',           // Cash On Delivery - Will invoice after production / before despatch
  account: 'account'    // Credit Account - Will generate invoice on delivery of items
}
export const OrderPaymentTypeLookup = [
  { name: 'Prepaid', value: OrderPaymentTypes.prepaid },
  { name: 'Cash On Delivery', value: OrderPaymentTypes.cod },
  { name: 'Account', value: OrderPaymentTypes.account }
]
export const OrderEventTagTypes = {
  quoteEmailed: 'quoteEmailed',
  orderEmailed: 'orderEmailed',
  orderSettingsUpdated: 'orderSettingsUpdated',
  orderPrepaidSkipped: 'orderPrepaidSkipped',
  orderCODSkipped: 'orderCODSkipped'
}


export const OrderItemEdgeworkTypes = {
  shortA: 'shortA',
  shortB: 'shortB',
  longA: 'longA',
  longB: 'longB',

  // Special flag for marking all round via editor
  // Not used for standard non-editor line items
  allRound: 'allRound'
}
export const OrderItemEdgeworkTypeLookup = [
  { name: 'Short A', value: OrderItemEdgeworkTypes.shortA },
  { name: 'Short B', value: OrderItemEdgeworkTypes.shortB },
  { name: 'Long A', value: OrderItemEdgeworkTypes.longA },
  { name: 'Long B', value: OrderItemEdgeworkTypes.longB },

  { name: 'All Round', value: OrderItemEdgeworkTypes.allRound },
]

// External Order Item Update
// How the system handles updates linked POs for to external order items when updating
export const OrderItemExternalUpdateTypes = {
  resetExternalSetup: 'resetExternalSetup',         // Reset all the purchase orders & start again
  ignoreExternalSetup: 'ignoreExternalSetup'        // Updates order items without modifying purchase orders
}

// Order Editor

// Cutout Types
// Must match LibraryItemTypes cut types in glass-designer/types
export const OrderEditorCutoutTypes = {
  radiusCut: 'radiusCut',           // Corner radius cuts on the shape itself (not within other cutouts)
  centerCutOut: 'centerCutOut',     // Classed as a 'hole' internally. Does not alter shape segments
  edgeCutOut: 'edgeCutOut',         // Edges. Start & end vertices form angle < 45
  cornerCutOut: 'cornerCutOut'      // Corner. Start & end vertices form angle > 45
}
export const OrderEditorCutoutTypeLookup = [
  { name: 'Radius Cut', value: OrderEditorCutoutTypes.radiusCut },
  { name: 'Center Cut Out', value: OrderEditorCutoutTypes.centerCutOut },
  { name: 'Edge Cut Out', value: OrderEditorCutoutTypes.edgeCutOut },
  { name: 'Corner Cut Out', value: OrderEditorCutoutTypes.cornerCutOut }
]

export const CutoutPolishFilterTypes = {
  any: 'any',
  polishedOnly: 'polishedOnly',
  unpolishedOnly: 'unpolishedOnly'
}
export const CutoutPolishFilterTypeLookup = [
  { name: 'Any', value: CutoutPolishFilterTypes.any },
  { name: 'Polished Only', value: CutoutPolishFilterTypes.polishedOnly },
  { name: 'Unpolished Only', value: CutoutPolishFilterTypes.unpolishedOnly },
]

export const OrderEditorGeometryShapeTypes = {
  circle: 'circle',
  rectangle: 'rectangle',
  polygon: 'polygon'
}
export const OrderEditorGeometryShapeTypeLookup = [
  { name: 'Circle', value: OrderEditorGeometryShapeTypes.circle },
  { name: 'Rectangle', value: OrderEditorGeometryShapeTypes.rectangle },
  { name: 'Polygon', value: OrderEditorGeometryShapeTypes.polygon }
]

// Shape Types
// Used by editor to flag the type of shape. Used for pricing models
// DEPRECATED
export const OrderEditorShapeTypes = {
  rectangle: 'rectangle',           // Rectangle with 4 sides & all corners 90 degrees
  simple: 'simple',                 // Rectangle with 4 sides, but one or more corners NOT 90 degrees
  regular: 'regular',               // Shape with only 5 sides or a perfect circle
  complex: 'complex',               // Shape with 6 or more sides or oval circle
}
// DEPRECATED
export const OrderEditorShapeTypeLookup = [
  { name: 'Rectangle', value: OrderEditorShapeTypes.rectangle },
  { name: 'Simple', value: OrderEditorShapeTypes.simple },
  { name: 'Regular', value: OrderEditorShapeTypes.regular },
  { name: 'Complex', value: OrderEditorShapeTypes.complex }
]


// Edgework setting types
// Edgeworks can have a value applied to control how services are linked & for internal reference
export const OrderEditorEdgeworkSettingTypes = {
  none: 'none',
  angle: 'angle',       // Angle setting (in degrees). Eg, mitre
  size: 'size',         // Size (in millimetres). Eg, bevel
}
export const OrderEditorEdgeworkSettingTypeLookup = [
  { name: 'None', value: OrderEditorEdgeworkSettingTypes.none },
  { name: 'Angle', value: OrderEditorEdgeworkSettingTypes.angle },
  { name: 'Size', value: OrderEditorEdgeworkSettingTypes.size }
]


// Order Editor Guideline Types
export const OrderEditorGuidelineType = {
  centerCutoutEdgeToEdge: 'centerCutoutEdgeToEdge',
  centerCutoutEdgeToPanelEdge: 'centerCutoutEdgeToPanelEdge',
  centerCutoutEdgeToPanelCorner: 'centerCutoutEdgeToPanelCorner',
  centerCutoutRadius: 'centerCutoutRadius',
  panelCornerRadius: 'panelCornerRadius',
  splitLimit: 'splitLimit'
}


// Purchase Orders
export const PurchaseOrderTypes = {
  bulk: 'bulk',
  standard: 'standard',
  externalOrder: 'externalOrder'
}
export const PurchaseOrderTypeLookup = [
  { name: 'Bulk', value: PurchaseOrderTypes.bulk },
  { name: 'Standard', value: PurchaseOrderTypes.standard },
  { name: 'External Order' , value: PurchaseOrderTypes.externalOrder },
]

export const PurchaseOrderStatusTypes = {
  pendingApproval: 'pendingApproval',         // Submitted for approval
  pendingConfirmation: 'pendingConfirmation', // Bulk Only: Sent to the supplier & waiting for them to confirm/advise the PO
  pendingShipping: 'pendingShipping',         // Bulk Only: Waiting for the purchase order to be shipped
  pendingReceival: 'pendingReceival',         // Delivery: Sent to supplier & pending receiving
  pendingAvailable: 'pendingAvailable',        // Pickup: Waiting for supplier to complete production / get stock
  pendingPickup: 'pendingPickup',             // Goods ready, registered in the system & waiting for pickup
  receiving: 'receiving',                     // Shipment received & user is processing received goods
  completed: 'completed',                     // All stock received & processed. PO is complete
  cancelled: 'cancelled'                      // PO Cancelled (by account or supplier)
}
export const PurchaseOrderStatusTypeLookup = [
  { name: 'Pending Approval', value: PurchaseOrderStatusTypes.pendingApproval },
  { name: 'Pending Confirmation', value: PurchaseOrderStatusTypes.pendingConfirmation },
  { name: 'Pending Shipping', value: PurchaseOrderStatusTypes.pendingShipping },
  { name: 'Pending Receival', value: PurchaseOrderStatusTypes.pendingReceival },
  { name: 'Pending Available', value: PurchaseOrderStatusTypes.pendingAvailable },
  { name: 'Pending Pickup', value: PurchaseOrderStatusTypes.pendingPickup },
  { name: 'Receiving', value: PurchaseOrderStatusTypes.receiving },
  { name: 'Completed', value: PurchaseOrderStatusTypes.completed },
  { name: 'Cancelled', value: PurchaseOrderStatusTypes.cancelled },
]


// Production
export const ProductionStageCategoryTypes = {
  general: 'general',
  cutting: 'cutting',
  waterjet: 'waterjet',
  furnace: 'furnace',
  assembly: 'assembly'
}
export const ProductionStageCategoryTypeLookup = [
  { name: 'General', value: ProductionStageCategoryTypes.general },
  { name: 'Cutting', value: ProductionStageCategoryTypes.cutting },
  { name: 'Waterjet', value: ProductionStageCategoryTypes.waterjet },
  { name: 'Furnace', value: ProductionStageCategoryTypes.furnace },
  { name: 'Assembly', value: ProductionStageCategoryTypes.assembly }
]

export const ProductionStationTypes = {
  general: 'general',
  feedIn: 'feedIn',
  cutting: 'cutting',
  cuttingOptimisation: 'cuttingOptimisation',
  cuttingBreakout: 'cuttingBreakout',
  waterjet: 'waterjet',
  furnace: 'furnace',
  furnaceUnload: 'furnaceUnload',
  assembly: 'assembly'
}
export const ProductionStationTypeLookup = [
  { name: 'General', value: ProductionStationTypes.general },
  { name: 'Feed In', value: ProductionStationTypes.feedIn },
  { name: 'Cutting', value: ProductionStationTypes.cutting },
  { name: 'Cutting - Optimisation', value: ProductionStationTypes.cuttingOptimisation },
  { name: 'Cutting - Optimisation Breakout', value: ProductionStationTypes.cuttingBreakout },
  { name: 'Waterjet', value: ProductionStationTypes.waterjet },
  { name: 'Furnace', value: ProductionStationTypes.furnace },
  { name: 'Furnace Unload', value: ProductionStationTypes.furnaceUnload },
  { name: 'Assembly', value: ProductionStationTypes.assembly }
]

// Panel Stage-Task Status Types
export const ProductionPanelStageTaskStatusTypes = {
  pending: 'pending',           // Waiting to be started
  production: 'production',     // Currently in production / scanned in
  completed: 'completed',       // Successfully completed
  cancelled: 'cancelled',       // Cancelled (recut, cancellation, etc)
}
export const ProductionPanelStageTaskStatusTypeLookup = [
  { name: 'Pending', value: ProductionPanelStageTaskStatusTypes.pending },
  { name: 'Production', value: ProductionPanelStageTaskStatusTypes.production },
  { name: 'Completed', value: ProductionPanelStageTaskStatusTypes.completed },
  { name: 'Cancelled', value: ProductionPanelStageTaskStatusTypes.cancelled },
]

// Production Panel Types
export const ProductionPanelTypes = {
  glass: 'glass',
  assembly: 'assembly'
}
export const ProductionPanelTypeLookup = [
  { name: 'Glass', value: ProductionPanelTypes.glass },
  { name: 'Assembly', value: ProductionPanelTypes.assembly },
]

// Panel Status Types
export const ProductionPanelStatusTypes = {
  pending: 'pending',           // Waiting to be cut
  production: 'production',     // Cut & in production
  recut: 'recut',               // Flagged as having an issue & no longer in production. New panel will be created as a recut
  despatch: 'despatch',         // Production complete & in despatch awaiting delivery/pickup
  completed: 'completed',       // Production complete, despatch complete & with the customer
  cancelled: 'cancelled'        // Production cancelled. Cancelled by customer & production stopped
}
export const ProductionPanelStatusTypeLookup = [
  { name: 'Pending', value: ProductionPanelStatusTypes.pending },
  { name: 'Production', value: ProductionPanelStatusTypes.production },
  { name: 'Recut', value: ProductionPanelStatusTypes.recut },
  { name: 'Despatch', value: ProductionPanelStatusTypes.despatch },
  { name: 'Completed', value: ProductionPanelStatusTypes.completed },
  { name: 'Cancelled', value: ProductionPanelStatusTypes.cancelled },
]

export const ProductionTransferStatusTypes = {
  pending: 'pending',           // Waiting to be started
  inProgress: 'inProgress',     // Assigned to a task & waiting for completion
  completed: 'completed',       // Successfully completed
  cancelled: 'cancelled',       // Cancelled (recut, cancellation, etc)
}
export const ProductionTransferStatusTypeLookup = [
  { name: 'Pending', value: ProductionTransferStatusTypes.pending },
  { name: 'In Progress', value: ProductionTransferStatusTypes.inProgress },
  { name: 'Completed', value: ProductionTransferStatusTypes.completed },
  { name: 'Cancelled', value: ProductionTransferStatusTypes.cancelled },
]

// Production Stage Lead Time Types
export const ProductionStageLeadTimeTypes = {
  static: 'static',           // Static lead time, fixed duration
  dynamic: 'dynamic'          // Dynamic lead time, calculated based on station(s) availability vs capacity
}
export const ProductionStageLeadTimeTypeLookup = [
  { name: 'Static', value: ProductionStageLeadTimeTypes.static },
  { name: 'Dynamic', value: ProductionStageLeadTimeTypes.dynamic }
]

export const ProductionPanelSessionTypes = {
  idle: 'idle',                 // Idle session, waiting for production
  production: 'production',     // Production session, currently being processed at a station
  despatch: 'despatch',         // Despatch session, waiting for despatch
  hold: 'hold',                 // Hold session, waiting for a order hold to be released
}

export const ProductionStationHardwareTypes = {
  generic: 'generic',     // Catch all for stations without a required hardware setting

  // Waterjet
  waterjetJetstream: 'waterjetJetstream',
  waterjetGeneric: 'waterjetGeneric',

  // Cutting
  cuttingIntermacFloat: 'cuttingIntermacFloat',
  cuttingIntermacLami: 'cuttingIntermacLami',
  cuttingOptimaCompatible: 'cuttingOptimaCompatible'
}
export const ProductionStationHardwareTypeLookup = [
  { name: 'Generic', value: ProductionStationHardwareTypes.generic },
  { name: 'Waterjet - Jetstream', value: ProductionStationHardwareTypes.waterjetJetstream },
  { name: 'Waterjet - Generic', value: ProductionStationHardwareTypes.waterjetGeneric },
  { name: 'Cutting - Intermac Float', value: ProductionStationHardwareTypes.cuttingIntermacFloat },
  { name: 'Cutting - Intermac Lami', value: ProductionStationHardwareTypes.cuttingIntermacLami },
  { name: 'Cutting - Optima Compatible', value: ProductionStationHardwareTypes.cuttingOptimaCompatible },
]
export const ProductionStationQueueDisplayTypes = {
  smallThumbnail: 'smallThumbnail',
  largeThumbnail: 'largeThumbnail',
  editorView: 'editorView'
}
export const ProductionStationQueueDisplayTypeLookup = [
  { name: 'Thumbnail - Small', value: ProductionStationQueueDisplayTypes.smallThumbnail },
  { name: 'Thumbnail - Large', value: ProductionStationQueueDisplayTypes.largeThumbnail },
  { name: 'Editor View', value: ProductionStationQueueDisplayTypes.editorView }
]

// Production - Station Specific Types
export const ProductionOptimisationCutTypes = {
  shape: 'shape',                   // Standard shaped (rectangle / circle) cuts
  guillotine: 'guillotine',         // Guillotine cuts only (edge to edge)
}
export const ProductionOptimisationCutTypeLookup = [
  { name: 'Shaped', value: ProductionOptimisationCutTypes.shape },
  { name: 'Guillotine', value: ProductionOptimisationCutTypes.guillotine }
]

export const ProductionWaterjetReliefTypes = {
  inline: 'inline',
  large: 'large'
}
export const ProductionWaterjetReliefTypeLookup = [
  { name: 'Inline', value: ProductionWaterjetReliefTypes.inline },
  { name: 'Large', value: ProductionWaterjetReliefTypes.large }
]

// Production Batch Status Types
export const ProductionBatchStatusTypes = {
  editing: 'editing',
  cutting: 'cutting',
  cancelled: 'cancelled',
  completed: 'completed'
}

// Production Toughening Batch
// Toughening Batch Compliance Types
export const ToughenBatchComplianceTypes = {
  standard: 'standard',
  automotive: 'automotive'
}
export const ToughenBatchComplianceTypeLookup = [
  { name: 'Standard', value: ToughenBatchComplianceTypes.standard },
  { name: 'Automotive', value: ToughenBatchComplianceTypes.automotive }
]

// Toughening Batch Glass Types
export const ToughenBatchGlassTypes = {
  standard: 'standard',     // Standard / Float
  pattern: 'pattern',
  coated: 'coated'
}
export const ToughenBatchGlassTypeLookup = [
  { name: 'Standard', value: ToughenBatchGlassTypes.standard },
  { name: 'Pattern', value: ToughenBatchGlassTypes.pattern },
  { name: 'Coated', value: ToughenBatchGlassTypes.coated }
]

// Toughening Batch Luminous Transmission Types
// Automotive compliance only
export const ToughenBatchLumenTransTypes = {
  clearFloat: 'clearFloat',   // VLT > 70%
  tinted: 'tinted'            // VLT < 70%
}
export const ToughenBatchLumenTransTypeLookup = [
  { name: 'Clear Float', value: ToughenBatchLumenTransTypes.clearFloat },
  { name: 'Tinted', value: ToughenBatchLumenTransTypes.tinted }
]

// Assembly Scanned Item Types
export const AssemblyScannedItemTypes = {
  general: 'general',         // General stock
  productionPanel: 'productionPanel',   // Production Item
}
export const AssemblyScannedItemTypeLookup = [
  { name: 'General', value: AssemblyScannedItemTypes.general },
  { name: 'Production Item', value: AssemblyScannedItemTypes.productionPanel },
]


// Optimiser

// Optimiser Sheet Types
export const OptimiserSheetTypes = {
  standard: 'standard',     // Standard sheet containing panels
  splitSheet: 'splitSheet'  // Sheet to be split based on data in the linked OrderItem
}
export const OptimiserSheetTypeLookup = [
  { name: 'Standard', value: OptimiserSheetTypes.standard },
  { name: 'Split Sheet', value: OptimiserSheetTypes.splitSheet }
]

// Optimiser Sheet Status
export const OptimiserSheetStatusTypes = {
  open: 'open',             // Open. Available for automatic updates
  processing: 'processing', // Processing while updated by backend system.
  editing: 'editing',       // Editing by user. Locked from any automatic updates, only by user request
  cutting: 'cutting',       // In process of cutting. Locked from any automatic / user updates until fully completed or cancelled
  completed: 'completed',   // Completed
  cancelled: 'cancelled'    // Cancelled
}
export const OptimiserSheetStatusTypeLookup = [
  { name: 'Open', value: OptimiserSheetStatusTypes.open },
  { name: 'Processing', value: OptimiserSheetStatusTypes.processing },
  { name: 'Editing', value: OptimiserSheetStatusTypes.editing },
  { name: 'Cutting', value: OptimiserSheetStatusTypes.cutting },
  { name: 'Completed', value: OptimiserSheetStatusTypes.completed },
  { name: 'Cancelled', value: OptimiserSheetStatusTypes.cancelled },
]

// Sheet Allocation Type
export const SheetAllocationTypes = {
  panel: 'panel',           // Panel, with links to ProductionPanel instance
  offcut: 'offcut',         // Offcut. Empty space, but big enough to be kept as an offcut
  waste: 'waste',           // Empty space, but not big enough to be used as an offcut
  defect: 'defect',         // Defect area in the sheet provided by the user
  panelScratchPad: 'panelScratchPad',   // Panel, not in the sheet but in a spare scratchpad area used by the editor to move panels around
  splitPanel: 'splitPanel',  // Rectangle used with the split sheet
  blankPanel: 'blankPanel'
}
export const SheetAllocationTypeLookup = [
  { name: 'Panel', value: SheetAllocationTypes.panel },
  { name: 'Offcut', value: SheetAllocationTypes.offcut },
  { name: 'Waste', value: SheetAllocationTypes.waste },
  { name: 'Defect', value: SheetAllocationTypes.defect },
  { name: 'Scratch Pad Panel', value: SheetAllocationTypes.panelScratchPad },
  { name: 'Split Sheet Panel', value: SheetAllocationTypes.splitPanel },
  { name: 'Blank Panel', value: SheetAllocationTypes.blankPanel },
]

// Sheet Allocation Status
export const SheetAllocationStatusTypes = {
  pending: 'pending',       // Pending, can be removed / changed
  completed: 'completed',   // Successfully cut & converted to a panel/offcut/wastage
}
export const SheetAllocationStatusTypeLookup = [
  { name: 'Pending', value: SheetAllocationStatusTypes.pending },
  { name: 'Completed', value: SheetAllocationStatusTypes.completed },
]

// Optimiser Sheet - Node Types
export const OptimiserSheetNodeTypes = {
  node: 'node',
  panel: 'panel',
  offcut: 'offcut',
  waste: 'waste',
  defect: 'defect'
}

// Optimiser Sheet - Node Split Direction Types
export const OptimiserNodeSplitDirTypes = {
  horizontal: 'horizontal',
  vertical: 'vertical'
}
export const OptimiserNodeSplitDirTypeLookup = [
  { name: 'Horizontal', value: OptimiserNodeSplitDirTypes.horizontal },
  { name: 'Vertical', value: OptimiserNodeSplitDirTypes.vertical }
]

// Optimiser - Fill Direction Types
export const OptimiserFillDirectionTypes = {
  up: 'up',
  down: 'down',
  right: 'right',
  left: 'left'
}
export const OptimiserFillDirectionTypeLookup = [
  { name: 'Up', value: OptimiserFillDirectionTypes.up },
  { name: 'Down', value: OptimiserFillDirectionTypes.down },
  { name: 'Right', value: OptimiserFillDirectionTypes.right },
  { name: 'Left', value: OptimiserFillDirectionTypes.left },
]

// Optimiser - Offcut Config Types
export const OffcutScoreConfigTypes = {
  greaterOffcutArea: 'greaterOffcutArea',     // More offcut area the better
  lesserOffcutCount: 'lesserOffcutCount'      // Less offcut count the better
}
export const OffcutScoreConfigTypeLookup = [
  { name: 'Greater Offcut Area', value: OffcutScoreConfigTypes.greaterOffcutArea },
  { name: 'Less Offcut Count', value: OffcutScoreConfigTypes.lesserOffcutCount }
]



// Tasks

// Task Types
// DEPRECATED - Uses TaskType now
export const TaskTypes = {
  general: 'general',
  install: 'install',
  pickup: 'pickup',
  delivery: 'delivery'
}

export const TaskItemTypes = {
  general: 'general',
  orderDespatch: 'orderDespatch',
  stoppage: 'stoppage',
  transferInternal: 'transferInternal',
  transferExternal: 'transferExternal',
  transferPickup: 'transferPickup'
}
export const TaskItemTypeLookup = [
  { name: 'General', value: TaskItemTypes.general },
  { name: 'Order Despatch', value: TaskItemTypes.orderDespatch },
  { name: 'Stoppage', value: TaskItemTypes.stoppage },
  { name: 'Transfer Internal', value: TaskItemTypes.transferInternal },
  { name: 'Transfer External', value: TaskItemTypes.transferExternal },
  { name: 'Transfer Pickup', value: TaskItemTypes.transferPickup }
]

// Task Status Types
export const TaskStatusTypes = {
  pendingApproval: 'pendingApproval',
  pendingProduction: 'pendingProduction',
  loading: 'loading',
  ready: 'ready',
  inProgress: 'inProgress',
  completed: 'completed',
  cancelled: 'cancelled'
}
export const TaskStatusTypeLookup = [
  { name: 'Pending Approval', value: TaskStatusTypes.pendingApproval },
  { name: 'Pending Production', value: TaskStatusTypes.pendingProduction },
  { name: 'Loading', value: TaskStatusTypes.loading },
  { name: 'Ready', value: TaskStatusTypes.ready },
  { name: 'In Progress', value: TaskStatusTypes.inProgress },
  { name: 'Completed', value: TaskStatusTypes.completed },
  { name: 'Cancelled', value: TaskStatusTypes.cancelled }
]

// Task Item Status Types
export const TaskItemStatusTypes = {
  pending: 'pending',
  active: 'active',
  completed: 'completed',
  cancelled: 'cancelled'
}
export const TaskItemStatusTypeLookup = [
  { name: 'Pending', value: TaskItemStatusTypes.pending },
  { name: 'Active', value: TaskItemStatusTypes.active },
  { name: 'Completed', value: TaskItemStatusTypes.completed },
  { name: 'Cancelled', value: TaskItemStatusTypes.cancelled }
]

// Task Approval Types
export const TaskApprovalTypes = {
  account: 'account'
}
export const TaskApprovalTypeLookup = {
  account: 'Account'
}


// Task Alert Types
export const TaskAlertTypes = {
  email: 'email',
  notification: 'notification'
}
export const TaskAlertTypeLookup = [
  { name: 'Email', value: TaskAlertTypes.email },
  { name: 'Notification', value: TaskAlertTypes.notification },
]

export const TaskSignoffTypes = {
  none: 'none',
  signature: 'signature',
  photoProof: 'photoProof'
}
export const TaskSignoffTypeLookup = [
  { name: 'None', value: TaskSignoffTypes.none },
  { name: 'Signature', value: TaskSignoffTypes.signature },
  { name: 'Photo Proof', value: TaskSignoffTypes.photoProof }
]

// Linked Item Types
// Items linked to a task item for despatch / transfer / reference
export const TaskLinkedItemTypes = {
  // Direct links for transfering stock / panels
  general: 'general',                 // General stock item
  glassLevel: 'glassLevel',           // Offcut / Loose Sheets / Blocks
  productionPanel: 'productionPanel', // Production Panel

  // Links to orders for despatch / general tasks
  order: 'order',                     // Order - Linked to orders for general tasks
  orderItem: 'orderItem',             // OrderItem - For despatch

  // Links to purchase orders for pickup/collection
  purchaseOrderItem: 'purchaseOrderItem'    // PurchaseOrderItem - For PO pickup/collection
}
export const TaskLinkedItemTypeLookup = [
  { name: 'General Stock', value: TaskLinkedItemTypes.general },
  { name: 'Glass', value: TaskLinkedItemTypes.glassLevel },
  { name: 'Production Panel', value: TaskLinkedItemTypes.productionPanel },
  { name: 'Order', value: TaskLinkedItemTypes.order },
  { name: 'Order Item', value: TaskLinkedItemTypes.orderItem },
  { name: 'Purchase Order Item', value: TaskLinkedItemTypes.purchaseOrderItem },
]

export const TaskTransferDirectionTypes = {
  in: 'in',   // Incoming back to the factory from supplier
  out: 'out'  // Outgoing to the supplier
}
export const TaskTransferDirectionTypeLookup = [
  { name: 'Incoming', value: TaskTransferDirectionTypes.in },
  { name: 'Outgoing', value: TaskTransferDirectionTypes.out }
]

// Task Item Scanned Types
export const ScannedItemTypes = {
  general: 'general',
  glassLevel: 'glassLevel',
  glassBlock: 'glassBlock',
  productionPanel: 'productionPanel'
}
export const ScannedItemTypeLookup = [
  { name: 'General Stock', value: ScannedItemTypes.general },
  { name: 'Sheet', value: ScannedItemTypes.glassLevel },
  { name: 'Block', value: ScannedItemTypes.glassBlock },
  { name: 'Production Panel', value: ScannedItemTypes.productionPanel }
]

// Task Route Start/End Location Types
export const TaskRouteLocationTypes = {
  none: 'none',
  accountLocation: 'accountLocation',
  currentUserLocation: 'currentUserLocation',
  address: 'address'
}
export const TaskRouteLocationTypeLookup = [
  { name: 'None', value: TaskRouteLocationTypes.none },
  { name: 'Account Location', value: TaskRouteLocationTypes.accountLocation },
  { name: 'Current User Location', value: TaskRouteLocationTypes.currentUserLocation },
  { name: 'Address', value: TaskRouteLocationTypes.address },
]

export const TaskUserRouteEventTypes = {
  stoppage: 'stoppage',
  signalLoss: 'signalLoss',
}
export const TaskUserRouteEventTypeLookup = [
  { name: 'Stoppage', value: TaskUserRouteEventTypes.stoppage },
  { name: 'Signal Loss', value: TaskUserRouteEventTypes.signalLoss },
]

// Task Type Invoicing Rules
export const TaskTypeInvoicingRuleTypes = {
  none: 'none',                               // Do not flag order items as despatched/invoiced/completioned
  despatchAndInvoice: 'despatchAndInvoice',   // Flags order items as despatched + invoices
  despatchOnly: 'despatchOnly',               // Flags order items as despatched/completed, but does not invoice until order completion
}
export const TaskTypeInvoicingRuleTypeLookup = [
  { name: 'None', value: TaskTypeInvoicingRuleTypes.none },
  { name: 'Despatch And Invoice', value: TaskTypeInvoicingRuleTypes.despatchAndInvoice },
  { name: 'Despatch Only', value: TaskTypeInvoicingRuleTypes.despatchOnly },
]

// Event Types
export const EventTypes = {
  general: 'general',
}

// Resource Group Types
export const ResourceGroupTypes = {
  general: 'general',
  productionStage: 'productionStage',   // V2, when merging production stages into resources
}
export const ResourceGroupTypeLookup = [
  { name: 'General', value: ResourceGroupTypes.general },
  //{ name: 'Production Stage', value: ResourceGroupTypes.productionStage },    // Disabled in V1
]

// Resource Types
export const ResourceTypes = {
  general: 'general',
  user: 'user',         // Resources linked to a User
}
export const ResourceTypeLookup = [
  { name: 'General', value: ResourceTypes.general },
  { name: 'User', value: ResourceTypes.user },
]

// Task Type Category Types
// Used for categorising task types with reporting
export const TaskTypeCategoryTypes = {
  outbound: 'outbound',         // Delivery / Install
  collection: 'collection',     // Pickup
  other: 'other',               // Other / Internal
}
export const TaskTypeCategoryTypeLookup = [
  { name: 'Outbound', value: TaskTypeCategoryTypes.outbound },
  { name: 'Collection', value: TaskTypeCategoryTypes.collection },
  { name: 'Other', value: TaskTypeCategoryTypes.other },
]

// Operational Reporting Codes - Set in Linked Items
// Used to categorise items for analytics during runsheet creation. Eg, why an order was late adding to the runsheet
// Some of these reference issues during the last attempt. Eg, despatch breakage during last run
// Required if TaskType.isOperationalReportingEnabled is true
export const ItemOperationalReportingCodes = {
  none: 'none',                                       // Not applicable / not set. Default value for non-despatch tasks, or if operational reporting not enabled

  // DIFOT Hit Codes
  onTime: 'onTime',                                   // Standard Request, despatched on time
  requestedEarlyMetEarly: 'requestedEarlyMetEarly',   // Requested earlier than standard lead time and despatched earlier than standard lead time
  requestedEarlyMetOnTime: 'requestedEarlyMetOnTime', // Requested earlier than standard lead time but despatched on time

  // DIFOT Miss Codes
  customerRequestedDateChange: 'customerRequestedDateChange',
  customerNotReady: 'customerNotReady',               // Site not ready / inaccessible at 
  customerRefused: 'customerRefused',
  customerLatePayment: 'customerLatePayment',

  requestEarlierNotReady: 'requestEarlierNotReady',   // Requested earlier, but not ready at time of runsheet creation
  productionNotReady: 'productionNotReady',           // Requested on time, but not ready at time of runsheet creation
  productionBreakage: 'productionBreakage',           // Breakage / quality issues in production at time of runsheet creation
  stockNotAvailable: 'stockNotAvailable',             // Stock not available at last attempt

  resourceOverCapacity: 'resourceOverCapacity',       // Resource (truck) over capacity at time of runsheet creation
  runOverCapacity: 'runOverCapacity',                 // Run over capacity at time of runsheet creation (eg, too many items / stops to fit on the run)
  runOptimised: 'runOptimised',                       // Run optimised to wait for more items to be ready

  resourceIssue: 'resourceIssue',                     // Issues with the resource (truck or driver) at time of runsheet creation (eg, breakdown, etc)
  despatchBreakage: 'despatchBreakage',               // Breakage during despatch during last attempt

  scheduled: 'scheduled',                             // Order is specifically scheduled (eg, stock / onsite) that can change

  externalIssue: 'externalIssue',                     // Issues outside of control of the business at time of runsheet creation (eg, traffic, weather, etc)
}
export const ItemOperationalReportingCategoryTypes = {
  success: 'success',
  customerCaused: 'customerCaused',
  customerEarlyRequest: 'customerEarlyRequest',
  runCapacity: 'runCapacity',
  productionCaused: 'productionCaused',
  logistics: 'logistics',
  external: 'external',
  notClassified: 'notClassified'
}
export const ItemOperationalReportingCategoryTypeLookup = [
  { name: 'Success', value: ItemOperationalReportingCategoryTypes.success },
  { name: 'Customer Caused', value: ItemOperationalReportingCategoryTypes.customerCaused },
  { name: 'Customer Early Request', value: ItemOperationalReportingCategoryTypes.customerEarlyRequest },
  { name: 'Run Capacity', value: ItemOperationalReportingCategoryTypes.runCapacity },
  { name: 'Production Caused', value: ItemOperationalReportingCategoryTypes.productionCaused },
  { name: 'Logistics', value: ItemOperationalReportingCategoryTypes.logistics },
  { name: 'External', value: ItemOperationalReportingCategoryTypes.external },
  { name: 'Not Classified', value: ItemOperationalReportingCategoryTypes.notClassified },
]

export const ItemOperationalReportingCodeLookup = [
  { name: 'None', value: ItemOperationalReportingCodes.none, description: 'Not applicable', category: ItemOperationalReportingCategoryTypes.notClassified },
  
  { name: 'On Time', value: ItemOperationalReportingCodes.onTime, description: 'Standard Request, despatched on time', category: ItemOperationalReportingCategoryTypes.success },

  { name: 'Customer Requested Date Change', value: ItemOperationalReportingCodes.customerRequestedDateChange, description: 'Customer requested a change in the delivery date', category: ItemOperationalReportingCategoryTypes.customerCaused },
  { name: 'Customer Not Ready', value: ItemOperationalReportingCodes.customerNotReady, description: 'Site not ready / inaccessible at time of delivery', category: ItemOperationalReportingCategoryTypes.customerCaused },
  { name: 'Customer Refused', value: ItemOperationalReportingCodes.customerRefused, description: 'Customer refused the delivery', category: ItemOperationalReportingCategoryTypes.customerCaused },
  { name: 'Customer Late Payment', value: ItemOperationalReportingCodes.customerLatePayment, description: 'Customer made a late payment delaying the order', category: ItemOperationalReportingCategoryTypes.customerCaused },

  { name: 'Requested Earlier & Met Earlier', value: ItemOperationalReportingCodes.requestedEarlyMetEarly, description: 'Requested earlier than standard lead time and despatched earlier than standard lead time', category: ItemOperationalReportingCategoryTypes.customerEarlyRequest },
  { name: 'Requested Earlier & Met On Time', value: ItemOperationalReportingCodes.requestedEarlyMetOnTime, description: 'Requested earlier than standard lead time but despatched on time', category: ItemOperationalReportingCategoryTypes.customerEarlyRequest },  
  { name: 'Requested Earlier But Not Ready', value: ItemOperationalReportingCodes.requestEarlierNotReady, description: 'Requested earlier, but not ready at time of runsheet creation', category: ItemOperationalReportingCategoryTypes.customerEarlyRequest },
  
  { name: 'Production Not Ready', value: ItemOperationalReportingCodes.productionNotReady, description: 'Requested on time, but not ready at time of runsheet creation', category: ItemOperationalReportingCategoryTypes.productionCaused },
  { name: 'Production Breakage', value: ItemOperationalReportingCodes.productionBreakage, description: 'Breakage / quality issues in production at time of runsheet creation', category: ItemOperationalReportingCategoryTypes.productionCaused },
  { name: 'Stock Not Available', value: ItemOperationalReportingCodes.stockNotAvailable, description: 'Stock not available at last attempt', category: ItemOperationalReportingCategoryTypes.productionCaused },

  { name: 'Resource Over Capacity', value: ItemOperationalReportingCodes.resourceOverCapacity, description: 'Resource (truck) over capacity at time of runsheet creation', category: ItemOperationalReportingCategoryTypes.runCapacity },
  { name: 'Run Over Capacity', value: ItemOperationalReportingCodes.runOverCapacity, description: 'Run over capacity at time of runsheet creation (eg, too many items / stops to fit on the run)', category: ItemOperationalReportingCategoryTypes.runCapacity },

  { name: 'Run Optimisation', value: ItemOperationalReportingCodes.runOptimised, description: 'Run optimised to wait for more items to be ready', category: ItemOperationalReportingCategoryTypes.logistics },
  { name: 'Resource Issue', value: ItemOperationalReportingCodes.resourceIssue, description: 'Issues with the resource (truck or driver) at time of runsheet creation (eg, breakdown, etc)', category: ItemOperationalReportingCategoryTypes.logistics },
  { name: 'Despatch Breakage', value: ItemOperationalReportingCodes.despatchBreakage, description: 'Breakage during despatch during last attempt', category: ItemOperationalReportingCategoryTypes.logistics },

  { name: 'Scheduled', value: ItemOperationalReportingCodes.scheduled, description: 'Order was scheduled for a specific date', category: ItemOperationalReportingCategoryTypes.external },  
  { name: 'External Issue', value: ItemOperationalReportingCodes.externalIssue, description: 'Issues outside of control of the business at time of runsheet creation (eg, traffic, weather, etc)', category: ItemOperationalReportingCategoryTypes.external },
]

export const OperationalReportingResultTypes = {
  none: 'none',
  hit: 'hit',
  miss: 'miss',
  exclude: 'exclude',
}
export const OperationalReportingResultTypeLookup = [
  { name: 'None', value: OperationalReportingResultTypes.none },
  { name: 'Hit', value: OperationalReportingResultTypes.hit },
  { name: 'Miss', value: OperationalReportingResultTypes.miss },
  { name: 'Exclude', value: OperationalReportingResultTypes.exclude },
]


// Accounts Module
export const FinancialAccountTypes = {
  invoice: 'invoice',
  accountsReceivable: 'accountsReceivable',
  bank: 'bank',   // Deprecated. Replaced by multiple bank accounts for payment types
  creditNotes: 'creditNotes',
  rounding: 'rounding',

  // Bank accounts based on payment types
  bankCash: 'bankCash',
  bankCreditCard: 'bankCreditCard',
  bankDirectDebit: 'bankDirectDebit',   // Note: This is for 'EFTPOS' payment types (wasn't deprecated properly)
  bankCheque: 'bankCheque',
  bankExternal: 'bankExternal'
}

export const InvoiceStatusTypes = {
  invoiced: 'invoiced',       // Sent & active
  paid: 'paid',               // Completely paid
  cancelled: 'cancelled'      // Cancelled & the invoice amount void
}
export const InvoiceStatusTypeLookup = [
  { name: 'Invoiced', value: InvoiceStatusTypes.invoiced },
  { name: 'Paid', value: InvoiceStatusTypes.paid },
  { name: 'Cancelled', value: InvoiceStatusTypes.cancelled },
]

export const OrderReservedPaymentStatusTypes = {
  available: 'available',     // Available & pending order invoiced
  completed: 'completed',     // Completed & allocated
  cancelled: 'cancelled'      // Cancelled & no longer reserved
}
export const OrderReservedPaymentStatusTypeLookup = [
  { name: 'Available', value: OrderReservedPaymentStatusTypes.available },
  { name: 'Completed', value: OrderReservedPaymentStatusTypes.completed },
  { name: 'Cancelled', value: OrderReservedPaymentStatusTypes.cancelled },
]
export const OrderReservedPaymentTypes = {
  overpayment: 'overpayment', // Overpayment reserved to an order
  creditNote: 'creditNote'    // CreditNote reserved to an order
}

export const PaymentStatusTypes = {
  authorised: 'authorised',
  cancelled: 'cancelled'      // If voided for some reason (bank, xero, etc)
}
export const PaymentStatusTypeLookup = [
  { name: 'Authorised', value: PaymentStatusTypes.authorised },
  { name: 'Cancelled', value: PaymentStatusTypes.cancelled },
]
export const OverpaymentStatusTypes = {
  pendingInvoice: 'pendingInvoice',   // Overpayment was made against an order & is waiting for the order to generate invoices
  unallocated: 'unallocated',         // Overpayment unallocated & available for allocated to invoices
  allocated: 'allocated',             // Overpayment fully allocated to invoices & closed
  cancelled: 'cancelled'              // Overpayment cancelled/voided due to bank, human error, etc
}
export const OverpaymentStatusTypeLookup = [
  { name: 'Pending Invoice', value: OverpaymentStatusTypes.pendingInvoice },
  { name: 'Unallocated', value: OverpaymentStatusTypes.unallocated },
  { name: 'Allocated', value: OverpaymentStatusTypes.allocated },
  { name: 'Cancelled', value: OverpaymentStatusTypes.cancelled }
]
export const InvoicePaymentAllocationTypes = {
  payment: 'payment',         // Direct payment via PaymentReceived
  overpayment: 'overpayment', // Overpayment allocated to pay part/all of an invoice
  creditNote: 'creditNote'    // CreditNote allocated to pay part/all of an invoice
}
export const InvoicePaymentAllocationTypeLookup = [
  { name: 'Payment', value: InvoicePaymentAllocationTypes.payment },
  { name: 'Overpayment', value: InvoicePaymentAllocationTypes.overpayment },
  { name: 'Credit Note', value: InvoicePaymentAllocationTypes.creditNote }
]

export const PaymentTypes = {
  cash: 'cash',
  creditCard: 'creditCard',
  EFTPOS: 'EFTPOS',
  cheque: 'cheque',
  external: 'external'        // External. Eg, from an integration like Xero/MYOB
}
export const PaymentTypeLookup = [
  { name: 'Cash', value: PaymentTypes.cash },
  { name: 'Credit Card', value: PaymentTypes.creditCard },
  { name: 'Direct Debit', value: PaymentTypes.EFTPOS },
  { name: 'Cheque', value: PaymentTypes.cheque },
  { name: 'External', value: PaymentTypes.external }
]

export const CreditNoteStatusTypes = {
  available: 'available',     // Credit available
  credited: 'credited',       // Full amount credited to invoice(s)
  cancelled: 'cancelled'      // If voided for some reason (bank, xero, etc)
}
export const CreditNoteStatusTypeLookup = [
  { name: 'Available', value: CreditNoteStatusTypes.available },
  { name: 'Credited', value: CreditNoteStatusTypes.credited },
  { name: 'Cancelled', value: CreditNoteStatusTypes.cancelled },
]


// Users Module
export const UserLabelTypes = {
  // DEPRECATED
  pickup: 'pickup',               // For users specifically associated with pickup
  pickupKiosk: 'pickupKiosk',     // For pickup kiosk users
  delivery: 'delivery',           // For users specifically associated with delivery
}

// Admin

// Account Product Features
// Account Products will contain one or more of these feature to allow access throughout the system
export const AccountProductFeatureTypes = {
  orderEditor: 'orderEditor',

  automations: 'automations',

  purchasingAdvanced: 'purchasingAdvanced',
  pricingAdvanced: 'pricingAdvanced',
  inventoryAdvanced: 'inventoryAdvanced',

  intelligence: 'intelligence',    

  production: 'production',     // Core production
  productionFurnace: 'productionFurnace',
  productionIGU: 'productionIGU',   // To be supported in 2022
  productionOptimisation: 'productionOptimisation',
}


// Account Label Types
export const AccountLabelTypes = {
  accounts: 'accounts',           // For AccountLocation associated with accounts
  deliveryDepot: 'deliveryDepot', // For AccountLocation associated with despatch - Deliveries
  pickupDepot: 'pickupDepot',     // For AccountLocation associated with despatch - Pickups
  stock: 'stock',                 // For AccountLocation associated with stock
}

// Print Label Config Types
export const PrintLabelTypes = {
  productionPanel: 'productionPanel',
  offcut: 'offcut',
  glassBlock: 'glassBlock',
  inventoryBin: 'inventoryBin'
}
export const PrintLabelTypeLookup = [
  { name: 'Production Panel', value: PrintLabelTypes.productionPanel },
  { name: 'Offcut', value: PrintLabelTypes.offcut },
  { name: 'Glass Block', value: PrintLabelTypes.glassBlock },
  { name: 'Inventory Bin', value: PrintLabelTypes.inventoryBin }
]

// Print Label Template Types
export const PrintLabelTemplateTypes = {
  productionPanelSmall: 'productionPanelSmall',
  productionPanelLarge: 'productionPanelLarge',
  offcut: 'offcut',
  glassBlock: 'glassBlock',
  inventoryBin: 'inventoryBin'
}
export const PrintLabelTemplateTypeLookup = [
  { name: 'Panel Small Label', value: PrintLabelTemplateTypes.productionPanelSmall },
  { name: 'Panel Large Label', value: PrintLabelTemplateTypes.productionPanelLarge },
  { name: 'Offcut', value: PrintLabelTemplateTypes.offcut },
  { name: 'Glass Block', value: PrintLabelTemplateTypes.glassBlock },
  { name: 'Inventory Bin', value: PrintLabelTemplateTypes.inventoryBin }
]

export const PrintLabelBarcodeTypes = {
  barcodeCode39: 'barcodeCode39',
  barcodeQR: 'barcodeQR'
}
export const PrintLabelBarcodeTypeLookup = [
  { name: 'Barcode 1D - Code 39', value: PrintLabelBarcodeTypes.barcodeCode39 },
  { name: 'Barcode 2D - QR', value: PrintLabelBarcodeTypes.barcodeQR },
]


// Account Settings Keys
export const AccountSettingKeys = {
  // Pricing Module Options
  pricingSystemType: 'pricingSystemType',

  // Inventory Module Options
  enableGlassBlocks: 'enableGlassBlocks',

  // Orders Module Options
  orderDeliveryFeeStockId: 'orderDeliveryFeeStockId',   // REPLACED BY NCR
  orderNCRDeliveryFeeStockId: 'orderNCRDeliveryFeeStockId',
  orderEntryCancellationFeeStockId: 'orderEntryCancellationFeeStockId',
  orderMinInvoiceFeeStockId: 'orderMinInvoiceFeeStockId',
  orderMinPriceFeeStockId: 'orderMinPriceFeeStockId',
  orderTemplateHandlingStockId: 'orderTemplateHandlingStockId',
  orderSameDayCutoffTime: 'orderSameDayCutoffTime',
  orderPrePaidGracePeriodTime: 'orderPrePaidGracePeriodTime',
  orderShowPreviewInDocument: 'orderShowPreviewInDocument',
  orderShowPreviewInProduction: 'orderShowPreviewInProduction',
  orderShowCustomerCopyInProduction: 'orderShowCustomerCopyInProduction',
  orderEnablePreProduction: 'orderEnablePreProduction',
  orderPreProdEnableSendOrder: 'orderPreProdEnableSendOrder',
  orderPreProdEnablePrintSheets: 'orderPreProdEnablePrintSheets',
  orderPreProdEnablePrintLabels: 'orderPreProdEnablePrintLabels',
  orderQuoteExpiryDays: 'orderQuoteExpiryDays',
  orderDespatchScanForceProductionEnabled: 'orderDespatchScanForceProductionEnabled',
  orderCustomFieldList: 'orderCustomFieldList',
  orderCustomFieldQR: 'orderCustomFieldQR',
  orderGenerateMarginEstimates: 'orderGenerateMarginEstimates',

  // Order Editor Module Options
  // Note: These are displayed via order editor config  
  annealedSplittingStockId: 'annealedSplittingStockId',
  laminateSplittingStockId: 'laminateSplittingStockId',
  annealedSplittingMaxSplits: 'annealedSplittingMaxSplits',
  laminateSplittingMaxSplits: 'laminateSplittingMaxSplits',
  orderEditorMaxSnappingCutLineSize: 'orderEditorMaxSnappingCutLineSize',
  orderEditorMinCuttingCornerRadius: 'orderEditorMinCuttingCornerRadius',
  orderEditorRequiresReview: 'orderEditorRequiresReview',
  orderEditorReviewByItem: 'orderEditorReviewByItem',
  orderEditorAutosaveEnabled: 'orderEditorAutosaveEnabled',
  orderEditorAutosaveInterval: 'orderEditorAutosaveInterval',

  // Accounts Options
  accountsAdjustmentAmountStockId: 'accountsAdjustmentAmountStockId',   // NCR adjustments
  accountsRoundingAdjustmentStockId: 'accountsRoundingAdjustmentStockId', // Rounding adjustments
  accountsRoundingMaximumAmount: 'accountsRoundingMaximumAmount',
  accountsRoundingTaxRateId: 'accountsRoundingTaxRateId',

  // Production Module Options
  productionTougheningBatchExpiryTime: 'productionTougheningBatchExpiryTime',
  productionTougheningBatchGraceTime: 'productionTougheningBatchGraceTime',
  productionTransferLeadTime: 'productionTransferLeadTime',
  productionNCRTotalLeadTime: 'productionNCRTotalLeadTime',

  // Optimiser Module Options
  optimiserVCutEnabled: 'optimiserVCutEnabled',
  optimiserVCutMaxDepth: 'optimiserVCutMaxDepth',
  optimiserVCutMinAngle: 'optimiserVCutMinAngle',

  // Task Module Options
  taskDespatchScanTaskItemsEnabled: 'taskDespatchScanTaskItemsEnabled',
  taskDespatchScanForceProductionEnabled: 'taskDespatchScanForceProductionEnabled',

  // Calendar Options
  productionScheduleUsePublicHolidays: 'productionScheduleUsePublicHolidays',
  taskScheduleUsePublicHolidays: 'taskScheduleUsePublicHolidays',
}

export const DescriptorLookupTypes = {
  stockAdjustReason: 'stockAdjustReason',
  poAdditionalCost: 'poAdditionalCost',
  addressLookup: 'addressLookup'
}
export const DescriptorLookupTypeLookup = [
  { name: 'Stock Adjust Reason', value: DescriptorLookupTypes.stockAdjustReason },
  { name: 'Purchase Order - Additional Cost', value: DescriptorLookupTypes.poAdditionalCost },
  { name: 'Address Lookup', value: DescriptorLookupTypes.addressLookup },
]

export const CommunicationMethodTypes = {
  email: 'email',
  sms: 'sms'
}
export const CommunicationMethodTypeLookup = [
  { name: 'Email', value: CommunicationMethodTypes.email },
  { name: 'SMS', value: CommunicationMethodTypes.sms },
]

export const MessageTemplateTypes = {
  invoice: 'invoice',
  creditNote: 'creditNote',
  quote: 'quote',
  order: 'order',
  delivery: 'delivery',
  purchaseOrder: 'purchaseOrder',
  customerPriceList: 'customerPriceList',
  paymentReceived: 'paymentReceived',
  customerStatement: 'customerStatement'
}
export const MessageTemplateTypeLookup = [
  { name: 'Invoice', value: MessageTemplateTypes.invoice },
  { name: 'Credit Note', value: MessageTemplateTypes.creditNote },
  { name: 'Quote', value: MessageTemplateTypes.quote },
  { name: 'Order', value: MessageTemplateTypes.order },
  { name: 'Delivery', value: MessageTemplateTypes.delivery },
  { name: 'Purchase Order', value: MessageTemplateTypes.purchaseOrder },
  { name: 'Customer Price List', value: MessageTemplateTypes.customerPriceList },
  { name: 'Payment Received', value: MessageTemplateTypes.paymentReceived },
  { name: 'Customer Statement', value: MessageTemplateTypes.customerStatement }
]
export const NotificationTypes = {
  push: 'push',               // Quick popup/push notification info
  message: 'message'          // Message. Persists longer in the system
}
export const NotificationTypeLookup = [
  { name: 'Push Notification', value: NotificationTypes.push },
  { name: 'Message', value: NotificationTypes.message },
]


export const ImportExportResourceTypes = {
  stock: 'stock',
  stockCategory: 'stockCategory',
  stockGlassPricing: 'stockGlassPricing',
  stockServicePricing: 'stockServicePricing',
  glassSizes: 'glassSizes',
  glassSupplierBulkPricing: 'glassSupplierBulkPricing',
  contact: 'contact'
}

// Based on convention between OpenAI/Anthropic
export const AIMessageRoleTypes = {
  system: 'system',
  report: 'report',
  user: 'user',
  assistant: 'assistant'
}

// AI Message content types
export const AIMessageContentTypes = {
  text: 'text',
  toolResult: 'toolResult'
}

// Agent Registered Type Ids
// Use to keep track of all agents per account & update prompts via code during software updates
// Synergy will maintain control over prompts, but accounts can change agent names / avatars
export const AIAgentRegisteredTypeIds = {
  salesManager: 'salesManager',
}


// Agent Registered Report Types
// Use to keep track of all agents per account & update prompts via code during software updates
// Synergy will maintain control over prompts, but accounts can change agent names / avatars
export const AIAgentReportRegisteredTypeIds = {
  salesManagerWeekSalesReport: 'salesManagerWeekSalesReport'
}

// SSE Chat Event Types
export const SSEChatEventTypes = {
  started: 'started',
  completed: 'completed',
  userMessage: 'userMessage',
  delta: 'delta',
  error: 'error',

  toolStarted: 'toolStarted',
  toolCompleted: 'toolCompleted',
  toolError: 'toolError',
}

export const AIAvatarTypes = {
  avatarMale1: 'avatarMale1',
  avatarMale2: 'avatarMale2',
  avatarMale3: 'avatarMale3',
  avatarMale4: 'avatarMale4',
  avatarMale5: 'avatarMale5',
  avatarMale6: 'avatarMale6',
  avatarMale7: 'avatarMale7',
  avatarMale8: 'avatarMale8',
  avatarFemale1: 'avatarFemale1',
  avatarFemale2: 'avatarFemale2',
  avatarFemale3: 'avatarFemale3',
  avatarFemale4: 'avatarFemale4',
  avatarFemale5: 'avatarFemale5',
  avatarFemale6: 'avatarFemale6',
  avatarFemale7: 'avatarFemale7',
  avatarFemale8: 'avatarFemale8'
}
export const AIAvatarTypeLookup = [
  { name: 'Avatar Male 1', value: AIAvatarTypes.avatarMale1 },
  { name: 'Avatar Male 2', value: AIAvatarTypes.avatarMale2 },
  { name: 'Avatar Male 3', value: AIAvatarTypes.avatarMale3 },
  { name: 'Avatar Male 4', value: AIAvatarTypes.avatarMale4 },
  { name: 'Avatar Male 5', value: AIAvatarTypes.avatarMale5 },
  { name: 'Avatar Male 6', value: AIAvatarTypes.avatarMale6 },
  { name: 'Avatar Male 7', value: AIAvatarTypes.avatarMale7 },
  { name: 'Avatar Male 8', value: AIAvatarTypes.avatarMale8 },
  { name: 'Avatar Female 1', value: AIAvatarTypes.avatarFemale1 },
  { name: 'Avatar Female 2', value: AIAvatarTypes.avatarFemale2 },
  { name: 'Avatar Female 3', value: AIAvatarTypes.avatarFemale3 },
  { name: 'Avatar Female 4', value: AIAvatarTypes.avatarFemale4 },
  { name: 'Avatar Female 5', value: AIAvatarTypes.avatarFemale5 },
  { name: 'Avatar Female 6', value: AIAvatarTypes.avatarFemale6 },
  { name: 'Avatar Female 7', value: AIAvatarTypes.avatarFemale7 },
  { name: 'Avatar Female 8', value: AIAvatarTypes.avatarFemale8 }
]